<template>
  <header role="navigation">
    <desktop :navigation="navigation" v-if="desktop" />
    <mobile :navigation="navigation" v-if="mobile" />
  </header>
</template>

<script>
import desktop from "./desktop-navbar";
import mobile from "./mobile-navbar";
export default {
  data() {
    return {
      navigation: {
        links: [
          {
            name: "Greener Apron",
            submenu: [
              {
                name: "Home",
                url: "https://www.starbucksglobalacademy.com/greener-apron"
              }
            ],
            url: "https://www.starbucksglobalacademy.com/greener-apron"
          },
          {
            name: "To Be Welcoming",
            url: "https://tobewelcoming.com",
            active: false,
            submenu: [
              {
                name: "Home",
                url: "https://tobewelcoming.com"
              },
              {
                name: "Learn more",
                url: "https://tobewelcoming.com/learn"
              },
              {
                name: "Resources",
                url: "https://tobewelcoming.com/resources"
              }
            ]
          },
          {
            name: "Coffee Academy",
            url: "/",
            active: true,
            submenu: [
              {
               name: "Home",
                url: "/"
              },
              {
                name: "About",
                url: "/about"
              },
              {
                name: "Ongoing Learning",
                url: "/ongoinglearning"
              }
            ]
          }
        ],
        cta: [
          {
            baseUrl: "https://www.starbucksglobalacademy.com/explore",
            name: "All Courses"
          },
          {
            baseUrl: "#",
            name: "Sign In"
          }
        ]
      },
      desktop: false,
      mobile: false
    };
  },
  components: {
    desktop,
    mobile
  },
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      if (window.innerWidth > 991) {
        this.desktop = true;
        this.mobile = false;
      } else {
        this.mobile = true;
        this.desktop = false;
      }
    }
  }
};
</script>

<style lang="scss">
.submenu {
  width: 100vw;
  position: absolute;
  left: 0;
  z-index: 1000;
}
.nav-link {
  color: #2a2a2a;
  font-size: 18px !important;
}
.submenu-container {
  display: none;
}
@media screen and (max-width: 991px) {
  .logo {
    width: 12rem;
  }
}
.nav-list:hover {
  background-color: #29413b !important;
  a {
    color: white !important;
    cursor: pointer;
  }
}
.is-submenu:hover .submenu-container {
  display: block;
}
.current-website--active {
  z-index: 999;
  .submenu-container {
    display: block !important;
  }
  background-color: #29413b !important;
  a {
    color: white !important;
    cursor: pointer;
  }
}
.nav-list--pages {
  margin-top: 20px;
}
</style>
